const numberFormatter = new Intl.NumberFormat('it-IT')

export const CAR_DETAILS_LOCATION_PREFIX = 'SixtItaly'

export const mapLocation = (location) =>
  location
    ? location.replace(new RegExp(CAR_DETAILS_LOCATION_PREFIX, 'i'), '') || '-'
    : location

export const getFormattedNumber = (value) =>
  value ? numberFormatter.format(value) : '-'

export const getFormattedKm = (km) => `${numberFormatter.format(km)} km`

export const getFormattedReconditioningEstCost = (reconditioningEstCost) =>
  reconditioningEstCost
    ? `€ ${numberFormatter.format(reconditioningEstCost)}`
    : '-'

export const getFormattedAmount = (value, round = false) =>
  value ? `€ ${numberFormatter.format(round ? Math.round(value) : value)}` : '-'

export const getSixtPrice = (car) =>
  car.prices?.[1] || car.price || car.sixtPrice || null
